import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
  FormlyModule,
} from '@ngx-formly/core';
import { FormlyFieldSelectProps } from '@ngx-formly/core/select';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { MultiSelectModule } from 'primeng/multiselect';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { FormlySelectOptionsPipe } from '../pipes/formly-select-options.pipe';

interface SelectProps extends FormlyFieldProps, FormlyFieldSelectProps {
  appendTo?: any;
  Clear?: any;
  filter?: boolean;
  multiple?: boolean;
  options?: any[] | Observable<any[]> | undefined;
  imageUrl?: string;
  selectedItem?: any;
}

export interface FormlySelectFieldConfig
  extends FormlyFieldConfig<SelectProps> {
  type: 'select' | Type<FormlyFieldSelect>;
}

@Component({
  selector: 'formly-field-primeng-select',
  standalone: true,
  providers: [],
  template: `
    <label [for]="id" class="custom-label required">
      {{ props.label }}
      @if (props.required) {
        *
      }
    </label>
    @if (props.multiple) {
      <p-multiSelect
        [placeholder]="props.placeholder"
        [formControl]="formControl"
        [options]="(props.options | formlySelectOptions: field | async) ?? []"
        [formlyAttributes]="field"
        [showClear]="!props.required"
        [appendTo]="props.appendTo"
        (onChange)="props.change && props.change(field, $event)"
        (onClear)="props.Clear && props.Clear(field, $event)"
      >
      </p-multiSelect>
    } @else {
      <p-dropdown
        [placeholder]="props.placeholder"
        [formControl]="formControl"
        [options]="(props.options | formlySelectOptions: field | async) ?? []"
        [formlyAttributes]="field"
        [showClear]="!props.required"
        [appendTo]="props.appendTo"
        [filter]="props.filter"
        (onChange)="props.change && props.change(field, $event)"
        (onClear)="props.Clear && props.Clear(field, $event)"
      >
      @if (props.selectedItem) {
      <ng-template pTemplate="selectedItem">
            <div class="d-flex align-items-center gap-2" *ngIf="props.selectedItem">
                <img
                    [src]="props.imageUrl"
                    style="width: 18px" />
                <div>{{ props.selectedItem.label }}</div>
            </div>
        </ng-template>
      }
      @if(props.imageUrl) {
      <ng-template let-option pTemplate="item">
            <div class="d-flex align-items-center gap-2">
                <img
                    [src]="props.imageUrl"
                    style="width: 18px" />
                <div>{{ option.label }}</div>
            </div>
        </ng-template>
      }
      </p-dropdown>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
    FormlyPrimeNGModule,
    DropdownModule,
    MultiSelectModule,
    CommonModule,
    FormlySelectOptionsPipe
  ],
})
export class FormlyFieldSelect extends FieldType<
  FieldTypeConfig<SelectProps>
> { }
